// This file is auto-generated by @hey-api/openapi-ts

import { queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import {
  activationActivate,
  activationVerifyToken,
  addFeedback,
  amazonLogin,
  amazonRegister,
  appleLogin,
  appleRegister,
  approveDeviceAuthorization,
  changeEmail,
  changePassword,
  completeRegistration,
  createBookingSession,
  createParentalControlsVerification,
  deleteParentalControlsVerification,
  deletePaymentBearer,
  downloadInvoicePdf,
  emailCheck,
  getBookable,
  getBookingPriceSummary,
  getBookingSession,
  getCommunicationPreferences,
  getDeviceAuthorization,
  getDevices,
  getHardwareProducts,
  getHomeZoneStatus,
  getInvoices,
  getOrderHistory,
  getParentalControlsVerification,
  getPaymentBearer,
  getPermissions,
  getPriceBreakdown,
  getRecentlyWatched,
  getReturnLabel,
  getSelfServiceToken,
  getSession,
  getSubscription,
  getSubscriptionCapabilities,
  getSummary,
  getUser,
  googleLogin,
  googleRegister,
  linkAppleIdentity,
  listOrders,
  logout,
  type Options,
  passwordBreachCheck,
  passwordResetConfirm,
  passwordResetRequest,
  passwordResetVerify,
  reAuthenticate,
  redeemFunkeOffer,
  refreshSession,
  registrationLocationEligibility,
  registrationRegister,
  removeAllDevices,
  removeDevice,
  requestCancellation,
  requestWithdrawal,
  resendEmailConfirmation,
  setSepaPayment,
  startItemReturn,
  switchBookingProduct,
  unsubscribeCommunicationPreferences,
  updateCommunicationPreferences,
  updateParentalControlsEnabled,
  updateParentalControlsPin,
  updatePersonalData,
  updateRecentlyWatched,
  verifyEmail,
} from '../sdk.gen';
import type {
  ActivationActivateData,
  ActivationActivateError,
  ActivationActivateResponse,
  ActivationVerifyTokenData,
  ActivationVerifyTokenError,
  ActivationVerifyTokenResponse,
  AddFeedbackData,
  AddFeedbackError,
  AddFeedbackResponse,
  AmazonLoginData,
  AmazonLoginError,
  AmazonLoginResponse,
  AmazonRegisterData,
  AmazonRegisterError,
  AmazonRegisterResponse,
  AppleLoginData,
  AppleLoginError,
  AppleLoginResponse,
  AppleRegisterData,
  AppleRegisterError,
  AppleRegisterResponse,
  ApproveDeviceAuthorizationData,
  ApproveDeviceAuthorizationError,
  ApproveDeviceAuthorizationResponse,
  ChangeEmailData,
  ChangeEmailError,
  ChangeEmailResponse,
  ChangePasswordData,
  ChangePasswordError,
  ChangePasswordResponse,
  CompleteRegistrationData,
  CompleteRegistrationError,
  CompleteRegistrationResponse,
  CreateBookingSessionData,
  CreateBookingSessionError,
  CreateBookingSessionResponse,
  CreateParentalControlsVerificationData,
  CreateParentalControlsVerificationError,
  CreateParentalControlsVerificationResponse,
  DeleteParentalControlsVerificationData,
  DeleteParentalControlsVerificationError,
  DeleteParentalControlsVerificationResponse,
  DeletePaymentBearerData,
  DeletePaymentBearerError,
  DeletePaymentBearerResponse,
  DownloadInvoicePdfData,
  DownloadInvoicePdfError,
  EmailCheckData,
  EmailCheckError,
  EmailCheckResponse,
  GetBookableData,
  GetBookableError,
  GetBookableResponse,
  GetBookingPriceSummaryData,
  GetBookingPriceSummaryError,
  GetBookingPriceSummaryResponse,
  GetBookingSessionData,
  GetBookingSessionError,
  GetBookingSessionResponse,
  GetCommunicationPreferencesData,
  GetCommunicationPreferencesError,
  GetCommunicationPreferencesResponse,
  GetDeviceAuthorizationData,
  GetDeviceAuthorizationError,
  GetDeviceAuthorizationResponse,
  GetDevicesData,
  GetDevicesError,
  GetDevicesResponse,
  GetHardwareProductsData,
  GetHardwareProductsError,
  GetHardwareProductsResponse,
  GetHomeZoneStatusData,
  GetHomeZoneStatusError,
  GetHomeZoneStatusResponse,
  GetInvoicesData,
  GetInvoicesError,
  GetInvoicesResponse,
  GetOrderHistoryData,
  GetOrderHistoryError,
  GetOrderHistoryResponse,
  GetParentalControlsVerificationData,
  GetParentalControlsVerificationError,
  GetParentalControlsVerificationResponse,
  GetPaymentBearerData,
  GetPaymentBearerError,
  GetPaymentBearerResponse,
  GetPermissionsData,
  GetPermissionsError,
  GetPermissionsResponse,
  GetPriceBreakdownData,
  GetPriceBreakdownError,
  GetPriceBreakdownResponse,
  GetRecentlyWatchedData,
  GetRecentlyWatchedError,
  GetRecentlyWatchedResponse,
  GetReturnLabelData,
  GetReturnLabelError,
  GetSelfServiceTokenData,
  GetSelfServiceTokenError,
  GetSelfServiceTokenResponse,
  GetSessionData,
  GetSessionError,
  GetSessionResponse,
  GetSubscriptionCapabilitiesData,
  GetSubscriptionCapabilitiesError,
  GetSubscriptionCapabilitiesResponse,
  GetSubscriptionData,
  GetSubscriptionError,
  GetSubscriptionResponse,
  GetSummaryData,
  GetSummaryError,
  GetSummaryResponse,
  GetUserData,
  GetUserError,
  GetUserResponse,
  GoogleLoginData,
  GoogleLoginError,
  GoogleLoginResponse,
  GoogleRegisterData,
  GoogleRegisterError,
  GoogleRegisterResponse,
  LinkAppleIdentityData,
  LinkAppleIdentityError,
  LinkAppleIdentityResponse,
  ListOrdersData,
  ListOrdersError,
  ListOrdersResponse,
  LogoutData,
  LogoutError,
  LogoutResponse,
  PasswordBreachCheckData,
  PasswordBreachCheckError,
  PasswordBreachCheckResponse,
  PasswordResetConfirmData,
  PasswordResetConfirmError,
  PasswordResetConfirmResponse,
  PasswordResetRequestData,
  PasswordResetRequestError,
  PasswordResetRequestResponse2,
  PasswordResetVerifyData,
  PasswordResetVerifyError,
  PasswordResetVerifyResponse,
  ReAuthenticateData,
  ReAuthenticateError,
  ReAuthenticateResponse,
  RedeemFunkeOfferData,
  RedeemFunkeOfferError,
  RedeemFunkeOfferResponse,
  RefreshSessionData,
  RefreshSessionError,
  RefreshSessionResponse,
  RegistrationLocationEligibilityData,
  RegistrationLocationEligibilityError,
  RegistrationLocationEligibilityResponse,
  RegistrationRegisterData,
  RegistrationRegisterError,
  RegistrationRegisterResponse,
  RemoveAllDevicesData,
  RemoveAllDevicesError,
  RemoveAllDevicesResponse,
  RemoveDeviceData,
  RemoveDeviceError,
  RemoveDeviceResponse,
  RequestCancellationData,
  RequestCancellationError,
  RequestCancellationResponse,
  RequestWithdrawalData,
  RequestWithdrawalError,
  RequestWithdrawalResponse,
  ResendEmailConfirmationData,
  ResendEmailConfirmationError,
  SetSepaPaymentData,
  SetSepaPaymentError,
  SetSepaPaymentResponse,
  StartItemReturnData,
  StartItemReturnError,
  StartItemReturnResponse,
  SwitchBookingProductData,
  SwitchBookingProductError,
  SwitchBookingProductResponse,
  UnsubscribeCommunicationPreferencesData,
  UnsubscribeCommunicationPreferencesError,
  UnsubscribeCommunicationPreferencesResponse,
  UpdateCommunicationPreferencesData,
  UpdateCommunicationPreferencesError,
  UpdateCommunicationPreferencesResponse,
  UpdateParentalControlsEnabledData,
  UpdateParentalControlsEnabledError,
  UpdateParentalControlsEnabledResponse,
  UpdateParentalControlsPinData,
  UpdateParentalControlsPinError,
  UpdateParentalControlsPinResponse,
  UpdatePersonalDataData,
  UpdatePersonalDataError,
  UpdatePersonalDataResponse,
  UpdateRecentlyWatchedData,
  UpdateRecentlyWatchedError,
  UpdateRecentlyWatchedResponse,
  VerifyEmailData,
  VerifyEmailError,
  VerifyEmailResponse,
} from '../types.gen';

export const amazonLoginMutation = (
  options?: Partial<Options<AmazonLoginData>>,
): UseMutationOptions<AmazonLoginResponse, AmazonLoginError, Options<AmazonLoginData>> => {
  const mutationOptions: UseMutationOptions<AmazonLoginResponse, AmazonLoginError, Options<AmazonLoginData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await amazonLogin({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Register an Amazon SSO identity and establish a session.
 */
export const amazonRegisterMutation = (
  options?: Partial<Options<AmazonRegisterData>>,
): UseMutationOptions<AmazonRegisterResponse, AmazonRegisterError, Options<AmazonRegisterData>> => {
  const mutationOptions: UseMutationOptions<AmazonRegisterResponse, AmazonRegisterError, Options<AmazonRegisterData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await amazonRegister({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const appleLoginMutation = (
  options?: Partial<Options<AppleLoginData>>,
): UseMutationOptions<AppleLoginResponse, AppleLoginError, Options<AppleLoginData>> => {
  const mutationOptions: UseMutationOptions<AppleLoginResponse, AppleLoginError, Options<AppleLoginData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await appleLogin({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Register an Apple SSO identity and establish a session.
 */
export const appleRegisterMutation = (
  options?: Partial<Options<AppleRegisterData>>,
): UseMutationOptions<AppleRegisterResponse, AppleRegisterError, Options<AppleRegisterData>> => {
  const mutationOptions: UseMutationOptions<AppleRegisterResponse, AppleRegisterError, Options<AppleRegisterData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await appleRegister({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const getDeviceAuthorizationQueryKey = (options: Options<GetDeviceAuthorizationData>) =>
  createQueryKey('getDeviceAuthorization', options);

/**
 * Read the state of a device-flow user code
 *
 * Returns the verification state of the user code a device is displaying, plus the
 * device name the auth-service derived from that device's user agent. Unknown and expired codes are a
 * 200 carrying NOT_EXISTING / EXPIRED, so a caller can name the reason instead of showing a generic
 * failure.
 */
export const getDeviceAuthorizationOptions = (options: Options<GetDeviceAuthorizationData>) =>
  queryOptions<
    GetDeviceAuthorizationResponse,
    GetDeviceAuthorizationError,
    GetDeviceAuthorizationResponse,
    ReturnType<typeof getDeviceAuthorizationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDeviceAuthorization({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDeviceAuthorizationQueryKey(options),
  });

/**
 * Approve or deny a device-flow user code
 *
 * Binds the signed-in account to the device that requested this user code; the
 * device receives its tokens on its next poll. Only a code in PENDING state can be decided.
 */
export const approveDeviceAuthorizationMutation = (
  options?: Partial<Options<ApproveDeviceAuthorizationData>>,
): UseMutationOptions<ApproveDeviceAuthorizationResponse, ApproveDeviceAuthorizationError, Options<ApproveDeviceAuthorizationData>> => {
  const mutationOptions: UseMutationOptions<
    ApproveDeviceAuthorizationResponse,
    ApproveDeviceAuthorizationError,
    Options<ApproveDeviceAuthorizationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await approveDeviceAuthorization({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const googleLoginMutation = (
  options?: Partial<Options<GoogleLoginData>>,
): UseMutationOptions<GoogleLoginResponse, GoogleLoginError, Options<GoogleLoginData>> => {
  const mutationOptions: UseMutationOptions<GoogleLoginResponse, GoogleLoginError, Options<GoogleLoginData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await googleLogin({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Register a Google SSO identity and establish a session.
 */
export const googleRegisterMutation = (
  options?: Partial<Options<GoogleRegisterData>>,
): UseMutationOptions<GoogleRegisterResponse, GoogleRegisterError, Options<GoogleRegisterData>> => {
  const mutationOptions: UseMutationOptions<GoogleRegisterResponse, GoogleRegisterError, Options<GoogleRegisterData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await googleRegister({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const logoutMutation = (
  options?: Partial<Options<LogoutData>>,
): UseMutationOptions<LogoutResponse, LogoutError, Options<LogoutData>> => {
  const mutationOptions: UseMutationOptions<LogoutResponse, LogoutError, Options<LogoutData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await logout({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const passwordBreachCheckQueryKey = (options: Options<PasswordBreachCheckData>) => createQueryKey('passwordBreachCheck', options);

/**
 * Check whether passwords with the given SHA-1 prefix appear in known breaches
 *
 * Returns the list of SHA-1 suffix + breach count pairs for the given 5-char hex prefix.
 * Implements k-anonymity: clients send only the first 5 chars of a SHA-1 password hash,
 * so the full password never leaves the browser.
 */
export const passwordBreachCheckOptions = (options: Options<PasswordBreachCheckData>) =>
  queryOptions<
    PasswordBreachCheckResponse,
    PasswordBreachCheckError,
    PasswordBreachCheckResponse,
    ReturnType<typeof passwordBreachCheckQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await passwordBreachCheck({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: passwordBreachCheckQueryKey(options),
  });

/**
 * Set a new password using a valid reset token
 */
export const passwordResetConfirmMutation = (
  options?: Partial<Options<PasswordResetConfirmData>>,
): UseMutationOptions<PasswordResetConfirmResponse, PasswordResetConfirmError, Options<PasswordResetConfirmData>> => {
  const mutationOptions: UseMutationOptions<PasswordResetConfirmResponse, PasswordResetConfirmError, Options<PasswordResetConfirmData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await passwordResetConfirm({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Request a password-reset email
 *
 * Always responds 202, regardless of whether the email is registered, so callers can't probe which addresses exist. Requires an X-Recaptcha-Token header carrying a reCAPTCHA v3 token minted for the password_reset action.
 */
export const passwordResetRequestMutation = (
  options?: Partial<Options<PasswordResetRequestData>>,
): UseMutationOptions<PasswordResetRequestResponse2, PasswordResetRequestError, Options<PasswordResetRequestData>> => {
  const mutationOptions: UseMutationOptions<PasswordResetRequestResponse2, PasswordResetRequestError, Options<PasswordResetRequestData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await passwordResetRequest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Verify a password-reset token (pre-flight before showing the form)
 */
export const passwordResetVerifyMutation = (
  options?: Partial<Options<PasswordResetVerifyData>>,
): UseMutationOptions<PasswordResetVerifyResponse, PasswordResetVerifyError, Options<PasswordResetVerifyData>> => {
  const mutationOptions: UseMutationOptions<PasswordResetVerifyResponse, PasswordResetVerifyError, Options<PasswordResetVerifyData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await passwordResetVerify({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Re-authenticate for step-up
 *
 * Verifies the user's password and returns a short-lived step-up token. Requires an X-Recaptcha-Token header carrying a reCAPTCHA v3 token minted for the re_authenticate action.
 */
export const reAuthenticateMutation = (
  options?: Partial<Options<ReAuthenticateData>>,
): UseMutationOptions<ReAuthenticateResponse, ReAuthenticateError, Options<ReAuthenticateData>> => {
  const mutationOptions: UseMutationOptions<ReAuthenticateResponse, ReAuthenticateError, Options<ReAuthenticateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await reAuthenticate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const refreshSessionMutation = (
  options?: Partial<Options<RefreshSessionData>>,
): UseMutationOptions<RefreshSessionResponse, RefreshSessionError, Options<RefreshSessionData>> => {
  const mutationOptions: UseMutationOptions<RefreshSessionResponse, RefreshSessionError, Options<RefreshSessionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await refreshSession({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete the parental controls verification (debug/reset)
 */
export const deleteParentalControlsVerificationMutation = (
  options?: Partial<Options<DeleteParentalControlsVerificationData>>,
): UseMutationOptions<
  DeleteParentalControlsVerificationResponse,
  DeleteParentalControlsVerificationError,
  Options<DeleteParentalControlsVerificationData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteParentalControlsVerificationResponse,
    DeleteParentalControlsVerificationError,
    Options<DeleteParentalControlsVerificationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteParentalControlsVerification({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getParentalControlsVerificationQueryKey = (options?: Options<GetParentalControlsVerificationData>) =>
  createQueryKey('getParentalControlsVerification', options);

/**
 * Get parental controls verification status
 */
export const getParentalControlsVerificationOptions = (options?: Options<GetParentalControlsVerificationData>) =>
  queryOptions<
    GetParentalControlsVerificationResponse,
    GetParentalControlsVerificationError,
    GetParentalControlsVerificationResponse,
    ReturnType<typeof getParentalControlsVerificationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getParentalControlsVerification({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getParentalControlsVerificationQueryKey(options),
  });

/**
 * Verify ID card and set parental controls PIN
 */
export const createParentalControlsVerificationMutation = (
  options?: Partial<Options<CreateParentalControlsVerificationData>>,
): UseMutationOptions<
  CreateParentalControlsVerificationResponse,
  CreateParentalControlsVerificationError,
  Options<CreateParentalControlsVerificationData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateParentalControlsVerificationResponse,
    CreateParentalControlsVerificationError,
    Options<CreateParentalControlsVerificationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createParentalControlsVerification({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Enable or disable the parental controls PIN
 */
export const updateParentalControlsEnabledMutation = (
  options?: Partial<Options<UpdateParentalControlsEnabledData>>,
): UseMutationOptions<
  UpdateParentalControlsEnabledResponse,
  UpdateParentalControlsEnabledError,
  Options<UpdateParentalControlsEnabledData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateParentalControlsEnabledResponse,
    UpdateParentalControlsEnabledError,
    Options<UpdateParentalControlsEnabledData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateParentalControlsEnabled({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Change the parental controls PIN
 */
export const updateParentalControlsPinMutation = (
  options?: Partial<Options<UpdateParentalControlsPinData>>,
): UseMutationOptions<UpdateParentalControlsPinResponse, UpdateParentalControlsPinError, Options<UpdateParentalControlsPinData>> => {
  const mutationOptions: UseMutationOptions<
    UpdateParentalControlsPinResponse,
    UpdateParentalControlsPinError,
    Options<UpdateParentalControlsPinData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateParentalControlsPin({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSessionQueryKey = (options?: Options<GetSessionData>) => createQueryKey('getSession', options);

export const getSessionOptions = (options?: Options<GetSessionData>) =>
  queryOptions<GetSessionResponse, GetSessionError, GetSessionResponse, ReturnType<typeof getSessionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSession({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSessionQueryKey(options),
  });

/**
 * Activate a sales-token and establish a session
 *
 * Requires an X-Recaptcha-Token header carrying a reCAPTCHA v3 token minted for the token_activation action.
 */
export const activationActivateMutation = (
  options?: Partial<Options<ActivationActivateData>>,
): UseMutationOptions<ActivationActivateResponse, ActivationActivateError, Options<ActivationActivateData>> => {
  const mutationOptions: UseMutationOptions<ActivationActivateResponse, ActivationActivateError, Options<ActivationActivateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await activationActivate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Verify a sales-token (activation pre-flight)
 */
export const activationVerifyTokenMutation = (
  options?: Partial<Options<ActivationVerifyTokenData>>,
): UseMutationOptions<ActivationVerifyTokenResponse, ActivationVerifyTokenError, Options<ActivationVerifyTokenData>> => {
  const mutationOptions: UseMutationOptions<
    ActivationVerifyTokenResponse,
    ActivationVerifyTokenError,
    Options<ActivationVerifyTokenData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await activationVerifyToken({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getInvoicesQueryKey = (options?: Options<GetInvoicesData>) => createQueryKey('getInvoices', options);

/**
 * invoices of the user
 */
export const getInvoicesOptions = (options?: Options<GetInvoicesData>) =>
  queryOptions<GetInvoicesResponse, GetInvoicesError, GetInvoicesResponse, ReturnType<typeof getInvoicesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInvoices({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getInvoicesQueryKey(options),
  });

export const downloadInvoicePdfQueryKey = (options: Options<DownloadInvoicePdfData>) => createQueryKey('downloadInvoicePdf', options);

/**
 * streams a single invoice PDF; the token binds the link to the user
 */
export const downloadInvoicePdfOptions = (options: Options<DownloadInvoicePdfData>) =>
  queryOptions<unknown, DownloadInvoicePdfError, unknown, ReturnType<typeof downloadInvoicePdfQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await downloadInvoicePdf({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: downloadInvoicePdfQueryKey(options),
  });

/**
 * removes the user's stored payment method; succeeds when none is stored
 */
export const deletePaymentBearerMutation = (
  options?: Partial<Options<DeletePaymentBearerData>>,
): UseMutationOptions<DeletePaymentBearerResponse, DeletePaymentBearerError, Options<DeletePaymentBearerData>> => {
  const mutationOptions: UseMutationOptions<DeletePaymentBearerResponse, DeletePaymentBearerError, Options<DeletePaymentBearerData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deletePaymentBearer({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPaymentBearerQueryKey = (options?: Options<GetPaymentBearerData>) => createQueryKey('getPaymentBearer', options);

/**
 * the user's current payment method
 */
export const getPaymentBearerOptions = (options?: Options<GetPaymentBearerData>) =>
  queryOptions<GetPaymentBearerResponse, GetPaymentBearerError, GetPaymentBearerResponse, ReturnType<typeof getPaymentBearerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPaymentBearer({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPaymentBearerQueryKey(options),
  });

export const getSelfServiceTokenQueryKey = (options?: Options<GetSelfServiceTokenData>) => createQueryKey('getSelfServiceToken', options);

/**
 * Billwerk self-service token for the payment SDK
 */
export const getSelfServiceTokenOptions = (options?: Options<GetSelfServiceTokenData>) =>
  queryOptions<
    GetSelfServiceTokenResponse,
    GetSelfServiceTokenError,
    GetSelfServiceTokenResponse,
    ReturnType<typeof getSelfServiceTokenQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSelfServiceToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSelfServiceTokenQueryKey(options),
  });

/**
 * Change the payment method to SEPA direct debit
 *
 * Proxies to customer-self-care, which runs the Schufa credit check and writes the SEPA mandate via the Billwerk partner gateway. The X-Recaptcha-Token is relayed to CSC unverified (CSC is the sole verifier); the reCAPTCHA action is pinned server-side. Requires an X-Recaptcha-Token header carrying a reCAPTCHA v3 token minted for the sepa_payment action.
 */
export const setSepaPaymentMutation = (
  options?: Partial<Options<SetSepaPaymentData>>,
): UseMutationOptions<SetSepaPaymentResponse, SetSepaPaymentError, Options<SetSepaPaymentData>> => {
  const mutationOptions: UseMutationOptions<SetSepaPaymentResponse, SetSepaPaymentError, Options<SetSepaPaymentData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await setSepaPayment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getBookableQueryKey = (options: Options<GetBookableData>) => createQueryKey('getBookable', options);

/**
 * Catalog data (display texts, logos, images) for a bookable, keyed by the productId/optionId from a subscription.
 */
export const getBookableOptions = (options: Options<GetBookableData>) =>
  queryOptions<GetBookableResponse, GetBookableError, GetBookableResponse, ReturnType<typeof getBookableQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBookable({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBookableQueryKey(options),
  });

/**
 * Creates a package-configuration booking session.
 */
export const createBookingSessionMutation = (
  options?: Partial<Options<CreateBookingSessionData>>,
): UseMutationOptions<CreateBookingSessionResponse, CreateBookingSessionError, Options<CreateBookingSessionData>> => {
  const mutationOptions: UseMutationOptions<CreateBookingSessionResponse, CreateBookingSessionError, Options<CreateBookingSessionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createBookingSession({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getBookingSessionQueryKey = (options: Options<GetBookingSessionData>) => createQueryKey('getBookingSession', options);

/**
 * Fetches an existing package-configuration booking session.
 */
export const getBookingSessionOptions = (options: Options<GetBookingSessionData>) =>
  queryOptions<GetBookingSessionResponse, GetBookingSessionError, GetBookingSessionResponse, ReturnType<typeof getBookingSessionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBookingSession({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBookingSessionQueryKey(options),
  });

export const getBookingPriceSummaryQueryKey = (options: Options<GetBookingPriceSummaryData>) =>
  createQueryKey('getBookingPriceSummary', options);

/**
 * Fetches the price summary of the product currently selected in a booking session.
 */
export const getBookingPriceSummaryOptions = (options: Options<GetBookingPriceSummaryData>) =>
  queryOptions<
    GetBookingPriceSummaryResponse,
    GetBookingPriceSummaryError,
    GetBookingPriceSummaryResponse,
    ReturnType<typeof getBookingPriceSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBookingPriceSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBookingPriceSummaryQueryKey(options),
  });

/**
 * Selects a different product in a package-configuration booking session.
 */
export const switchBookingProductMutation = (
  options?: Partial<Options<SwitchBookingProductData>>,
): UseMutationOptions<SwitchBookingProductResponse, SwitchBookingProductError, Options<SwitchBookingProductData>> => {
  const mutationOptions: UseMutationOptions<SwitchBookingProductResponse, SwitchBookingProductError, Options<SwitchBookingProductData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await switchBookingProduct({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Hand the customer's data to Funke and return their basket URL
 *
 * Requires a paid subscription. Every call creates a new basket upstream — there is no idempotency, so a retry is a second basket. Requires an X-Recaptcha-Token header carrying a reCAPTCHA v3 token minted for the funke_redeem action.
 */
export const redeemFunkeOfferMutation = (
  options?: Partial<Options<RedeemFunkeOfferData>>,
): UseMutationOptions<RedeemFunkeOfferResponse, RedeemFunkeOfferError, Options<RedeemFunkeOfferData>> => {
  const mutationOptions: UseMutationOptions<RedeemFunkeOfferResponse, RedeemFunkeOfferError, Options<RedeemFunkeOfferData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await redeemFunkeOffer({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Requires an X-Recaptcha-Token header carrying a reCAPTCHA v3 token minted for the request_cancellation action.
 */
export const requestCancellationMutation = (
  options?: Partial<Options<RequestCancellationData>>,
): UseMutationOptions<RequestCancellationResponse, RequestCancellationError, Options<RequestCancellationData>> => {
  const mutationOptions: UseMutationOptions<RequestCancellationResponse, RequestCancellationError, Options<RequestCancellationData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await requestCancellation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCommunicationPreferencesQueryKey = (options?: Options<GetCommunicationPreferencesData>) =>
  createQueryKey('getCommunicationPreferences', options);

export const getCommunicationPreferencesOptions = (options?: Options<GetCommunicationPreferencesData>) =>
  queryOptions<
    GetCommunicationPreferencesResponse,
    GetCommunicationPreferencesError,
    GetCommunicationPreferencesResponse,
    ReturnType<typeof getCommunicationPreferencesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCommunicationPreferences({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCommunicationPreferencesQueryKey(options),
  });

export const unsubscribeCommunicationPreferencesMutation = (
  options?: Partial<Options<UnsubscribeCommunicationPreferencesData>>,
): UseMutationOptions<
  UnsubscribeCommunicationPreferencesResponse,
  UnsubscribeCommunicationPreferencesError,
  Options<UnsubscribeCommunicationPreferencesData>
> => {
  const mutationOptions: UseMutationOptions<
    UnsubscribeCommunicationPreferencesResponse,
    UnsubscribeCommunicationPreferencesError,
    Options<UnsubscribeCommunicationPreferencesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await unsubscribeCommunicationPreferences({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updateCommunicationPreferencesMutation = (
  options?: Partial<Options<UpdateCommunicationPreferencesData>>,
): UseMutationOptions<
  UpdateCommunicationPreferencesResponse,
  UpdateCommunicationPreferencesError,
  Options<UpdateCommunicationPreferencesData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateCommunicationPreferencesResponse,
    UpdateCommunicationPreferencesError,
    Options<UpdateCommunicationPreferencesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateCommunicationPreferences({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getDevicesQueryKey = (options?: Options<GetDevicesData>) => createQueryKey('getDevices', options);

export const getDevicesOptions = (options?: Options<GetDevicesData>) =>
  queryOptions<GetDevicesResponse, GetDevicesError, GetDevicesResponse, ReturnType<typeof getDevicesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDevices({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDevicesQueryKey(options),
  });

export const removeAllDevicesMutation = (
  options?: Partial<Options<RemoveAllDevicesData>>,
): UseMutationOptions<RemoveAllDevicesResponse, RemoveAllDevicesError, Options<RemoveAllDevicesData>> => {
  const mutationOptions: UseMutationOptions<RemoveAllDevicesResponse, RemoveAllDevicesError, Options<RemoveAllDevicesData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeAllDevices({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const removeDeviceMutation = (
  options?: Partial<Options<RemoveDeviceData>>,
): UseMutationOptions<RemoveDeviceResponse, RemoveDeviceError, Options<RemoveDeviceData>> => {
  const mutationOptions: UseMutationOptions<RemoveDeviceResponse, RemoveDeviceError, Options<RemoveDeviceData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeDevice({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const emailCheckQueryKey = (options: Options<EmailCheckData>) => createQueryKey('emailCheck', options);

/**
 * Check if email is available
 *
 * Returns whether the given email can be used to register a new account. If unavailable, takenBy indicates which provider/system owns it.
 */
export const emailCheckOptions = (options: Options<EmailCheckData>) =>
  queryOptions<EmailCheckResponse, EmailCheckError, EmailCheckResponse, ReturnType<typeof emailCheckQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await emailCheck({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: emailCheckQueryKey(options),
  });

export const addFeedbackMutation = (
  options?: Partial<Options<AddFeedbackData>>,
): UseMutationOptions<AddFeedbackResponse, AddFeedbackError, Options<AddFeedbackData>> => {
  const mutationOptions: UseMutationOptions<AddFeedbackResponse, AddFeedbackError, Options<AddFeedbackData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await addFeedback({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getHardwareProductsQueryKey = (options?: Options<GetHardwareProductsData>) => createQueryKey('getHardwareProducts', options);

/**
 * Get all hardware products
 */
export const getHardwareProductsOptions = (options?: Options<GetHardwareProductsData>) =>
  queryOptions<
    GetHardwareProductsResponse,
    GetHardwareProductsError,
    GetHardwareProductsResponse,
    ReturnType<typeof getHardwareProductsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHardwareProducts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHardwareProductsQueryKey(options),
  });

export const getHomeZoneStatusQueryKey = (options?: Options<GetHomeZoneStatusData>) => createQueryKey('getHomeZoneStatus', options);

/**
 * Current home-network (WLAN) registration status for the authenticated customer. 404 if no home network is set.
 */
export const getHomeZoneStatusOptions = (options?: Options<GetHomeZoneStatusData>) =>
  queryOptions<GetHomeZoneStatusResponse, GetHomeZoneStatusError, GetHomeZoneStatusResponse, ReturnType<typeof getHomeZoneStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHomeZoneStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHomeZoneStatusQueryKey(options),
  });

export const getReturnLabelQueryKey = (options: Options<GetReturnLabelData>) => createQueryKey('getReturnLabel', options);

/**
 * streams a return-label PDF from the selected logistics provider
 */
export const getReturnLabelOptions = (options: Options<GetReturnLabelData>) =>
  queryOptions<unknown, GetReturnLabelError, unknown, ReturnType<typeof getReturnLabelQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getReturnLabel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getReturnLabelQueryKey(options),
  });

export const getOrderHistoryQueryKey = (options?: Options<GetOrderHistoryData>) => createQueryKey('getOrderHistory', options);

export const getOrderHistoryOptions = (options?: Options<GetOrderHistoryData>) =>
  queryOptions<GetOrderHistoryResponse, GetOrderHistoryError, GetOrderHistoryResponse, ReturnType<typeof getOrderHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrderHistory({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrderHistoryQueryKey(options),
  });

export const startItemReturnMutation = (
  options?: Partial<Options<StartItemReturnData>>,
): UseMutationOptions<StartItemReturnResponse, StartItemReturnError, Options<StartItemReturnData>> => {
  const mutationOptions: UseMutationOptions<StartItemReturnResponse, StartItemReturnError, Options<StartItemReturnData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await startItemReturn({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listOrdersQueryKey = (options?: Options<ListOrdersData>) => createQueryKey('listOrders', options);

export const listOrdersOptions = (options?: Options<ListOrdersData>) =>
  queryOptions<ListOrdersResponse, ListOrdersError, ListOrdersResponse, ReturnType<typeof listOrdersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listOrders({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listOrdersQueryKey(options),
  });

export const getPermissionsQueryKey = (options?: Options<GetPermissionsData>) => createQueryKey('getPermissions', options);

/**
 * Current permission/consent status of the authenticated user.
 */
export const getPermissionsOptions = (options?: Options<GetPermissionsData>) =>
  queryOptions<GetPermissionsResponse, GetPermissionsError, GetPermissionsResponse, ReturnType<typeof getPermissionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPermissions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPermissionsQueryKey(options),
  });

export const getPriceBreakdownQueryKey = (options?: Options<GetPriceBreakdownData>) => createQueryKey('getPriceBreakdown', options);

/**
 * pricebreakdown of the users subscription
 */
export const getPriceBreakdownOptions = (options?: Options<GetPriceBreakdownData>) =>
  queryOptions<GetPriceBreakdownResponse, GetPriceBreakdownError, GetPriceBreakdownResponse, ReturnType<typeof getPriceBreakdownQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPriceBreakdown({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPriceBreakdownQueryKey(options),
  });

export const getSummaryQueryKey = (options?: Options<GetSummaryData>) => createQueryKey('getSummary', options);

/**
 * recording summary of the user
 */
export const getSummaryOptions = (options?: Options<GetSummaryData>) =>
  queryOptions<GetSummaryResponse, GetSummaryError, GetSummaryResponse, ReturnType<typeof getSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSummaryQueryKey(options),
  });

/**
 * Register a new waipu.tv customer (email/password).
 *
 * Requires an X-Recaptcha-Token header carrying a reCAPTCHA v3 token minted for the registration action.
 */
export const registrationRegisterMutation = (
  options?: Partial<Options<RegistrationRegisterData>>,
): UseMutationOptions<RegistrationRegisterResponse, RegistrationRegisterError, Options<RegistrationRegisterData>> => {
  const mutationOptions: UseMutationOptions<RegistrationRegisterResponse, RegistrationRegisterError, Options<RegistrationRegisterData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await registrationRegister({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Complete a freshly registered profile (mrf fields) and record consent.
 */
export const completeRegistrationMutation = (
  options?: Partial<Options<CompleteRegistrationData>>,
): UseMutationOptions<CompleteRegistrationResponse, CompleteRegistrationError, Options<CompleteRegistrationData>> => {
  const mutationOptions: UseMutationOptions<CompleteRegistrationResponse, CompleteRegistrationError, Options<CompleteRegistrationData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await completeRegistration({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const registrationLocationEligibilityQueryKey = (options?: Options<RegistrationLocationEligibilityData>) =>
  createQueryKey('registrationLocationEligibility', options);

/**
 * Whether the client's location is eligible for registration (German region).
 */
export const registrationLocationEligibilityOptions = (options?: Options<RegistrationLocationEligibilityData>) =>
  queryOptions<
    RegistrationLocationEligibilityResponse,
    RegistrationLocationEligibilityError,
    RegistrationLocationEligibilityResponse,
    ReturnType<typeof registrationLocationEligibilityQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await registrationLocationEligibility({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: registrationLocationEligibilityQueryKey(options),
  });

export const getRecentlyWatchedQueryKey = (options?: Options<GetRecentlyWatchedData>) => createQueryKey('getRecentlyWatched', options);

export const getRecentlyWatchedOptions = (options?: Options<GetRecentlyWatchedData>) =>
  queryOptions<
    GetRecentlyWatchedResponse,
    GetRecentlyWatchedError,
    GetRecentlyWatchedResponse,
    ReturnType<typeof getRecentlyWatchedQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRecentlyWatched({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getRecentlyWatchedQueryKey(options),
  });

export const updateRecentlyWatchedMutation = (
  options?: Partial<Options<UpdateRecentlyWatchedData>>,
): UseMutationOptions<UpdateRecentlyWatchedResponse, UpdateRecentlyWatchedError, Options<UpdateRecentlyWatchedData>> => {
  const mutationOptions: UseMutationOptions<
    UpdateRecentlyWatchedResponse,
    UpdateRecentlyWatchedError,
    Options<UpdateRecentlyWatchedData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateRecentlyWatched({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSubscriptionQueryKey = (options?: Options<GetSubscriptionData>) => createQueryKey('getSubscription', options);

/**
 * subscription of the user
 */
export const getSubscriptionOptions = (options?: Options<GetSubscriptionData>) =>
  queryOptions<GetSubscriptionResponse, GetSubscriptionError, GetSubscriptionResponse, ReturnType<typeof getSubscriptionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSubscription({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSubscriptionQueryKey(options),
  });

export const getSubscriptionCapabilitiesQueryKey = (options?: Options<GetSubscriptionCapabilitiesData>) =>
  createQueryKey('getSubscriptionCapabilities', options);

/**
 * capabilities of the users subscription
 */
export const getSubscriptionCapabilitiesOptions = (options?: Options<GetSubscriptionCapabilitiesData>) =>
  queryOptions<
    GetSubscriptionCapabilitiesResponse,
    GetSubscriptionCapabilitiesError,
    GetSubscriptionCapabilitiesResponse,
    ReturnType<typeof getSubscriptionCapabilitiesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSubscriptionCapabilities({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSubscriptionCapabilitiesQueryKey(options),
  });

export const getUserQueryKey = (options?: Options<GetUserData>) => createQueryKey('getUser', options);

export const getUserOptions = (options?: Options<GetUserData>) =>
  queryOptions<GetUserResponse, GetUserError, GetUserResponse, ReturnType<typeof getUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUserQueryKey(options),
  });

/**
 * Link a verified Sign in with Apple identity onto the authenticated account.
 */
export const linkAppleIdentityMutation = (
  options?: Partial<Options<LinkAppleIdentityData>>,
): UseMutationOptions<LinkAppleIdentityResponse, LinkAppleIdentityError, Options<LinkAppleIdentityData>> => {
  const mutationOptions: UseMutationOptions<LinkAppleIdentityResponse, LinkAppleIdentityError, Options<LinkAppleIdentityData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await linkAppleIdentity({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const changeEmailMutation = (
  options?: Partial<Options<ChangeEmailData>>,
): UseMutationOptions<ChangeEmailResponse, ChangeEmailError, Options<ChangeEmailData>> => {
  const mutationOptions: UseMutationOptions<ChangeEmailResponse, ChangeEmailError, Options<ChangeEmailData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await changeEmail({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const changePasswordMutation = (
  options?: Partial<Options<ChangePasswordData>>,
): UseMutationOptions<ChangePasswordResponse, ChangePasswordError, Options<ChangePasswordData>> => {
  const mutationOptions: UseMutationOptions<ChangePasswordResponse, ChangePasswordError, Options<ChangePasswordData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await changePassword({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const resendEmailConfirmationMutation = (
  options?: Partial<Options<ResendEmailConfirmationData>>,
): UseMutationOptions<unknown, ResendEmailConfirmationError, Options<ResendEmailConfirmationData>> => {
  const mutationOptions: UseMutationOptions<unknown, ResendEmailConfirmationError, Options<ResendEmailConfirmationData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await resendEmailConfirmation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updatePersonalDataMutation = (
  options?: Partial<Options<UpdatePersonalDataData>>,
): UseMutationOptions<UpdatePersonalDataResponse, UpdatePersonalDataError, Options<UpdatePersonalDataData>> => {
  const mutationOptions: UseMutationOptions<UpdatePersonalDataResponse, UpdatePersonalDataError, Options<UpdatePersonalDataData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updatePersonalData({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const verifyEmailMutation = (
  options?: Partial<Options<VerifyEmailData>>,
): UseMutationOptions<VerifyEmailResponse, VerifyEmailError, Options<VerifyEmailData>> => {
  const mutationOptions: UseMutationOptions<VerifyEmailResponse, VerifyEmailError, Options<VerifyEmailData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await verifyEmail({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Requires an X-Recaptcha-Token header carrying a reCAPTCHA v3 token minted for the request_withdrawal action.
 */
export const requestWithdrawalMutation = (
  options?: Partial<Options<RequestWithdrawalData>>,
): UseMutationOptions<RequestWithdrawalResponse, RequestWithdrawalError, Options<RequestWithdrawalData>> => {
  const mutationOptions: UseMutationOptions<RequestWithdrawalResponse, RequestWithdrawalError, Options<RequestWithdrawalData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await requestWithdrawal({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
